import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Icon3dot } from '../../../../assets/icon';
import ButtonTypes from '../../../../constants/buttonTypes';
import ButtonDropdownMenuItem from '../../../../components/ButtonDropdownMenuItem/ButtonDropdownMenuItem';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../../common/permissionGroup';
import CustomDropdownMenu from '../../../../components/CustomDropdownMenu/CustomDropdownMenu';

const actionButtonClassName = 'p-0 w-[26px] h-[26px] min-w-[26px] min-h-[26px]';
const actionContainerClassName = 'min-w-[220px] md:min-w-[250px]';

const OrderedPartsActions = ({
  side, onEdit, onDelete, onArchived, onDelivered, onCorrection
}) => {
  const [visible, toggleVisible] = useState(false);
  return (
    <CustomDropdownMenu
      Icon={Icon3dot}
      btnType={ButtonTypes.LIGHT}
      side={side}
      drop="right"
      mobileDrop="left"
      btnStyle={actionButtonClassName}
      containerStyle={actionContainerClassName}
      visible={visible}
      toggleVisible={toggleVisible}
    >
      <ButtonDropdownMenuItem
        text="Edit"
        onClick={() => {
          onEdit();
          toggleVisible(false);
        }}
      />
      <ButtonDropdownMenuItem
        text="delivered"
        onClick={() => {
          onDelivered();
          toggleVisible(false);
        }}
      />
      <ButtonDropdownMenuItem
        text="correction"
        onClick={() => {
          onCorrection();
          toggleVisible(false);
        }}
      />
      <ButtonDropdownMenuItem
        text="Archived"
        onClick={() => {
          onArchived();
          toggleVisible(false);
        }}
      />
      <PermissionsGate can={permissions.COW_DELETE}>
        <ButtonDropdownMenuItem
          danger
          text="delete"
          onClick={() => {
            onDelete();
            toggleVisible(false);
          }}
        />
      </PermissionsGate>
    </CustomDropdownMenu>
  );
};

OrderedPartsActions.propTypes = {
  side: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onArchived: PropTypes.func,
  onDelivered: PropTypes.func,
  onCorrection: PropTypes.func,
};

OrderedPartsActions.defaultProps = {
  side: 'top',
  onEdit: undefined,
  onDelete: undefined,
  onArchived: undefined,
  onDelivered: undefined,
  onCorrection: undefined,
};

export default OrderedPartsActions;
